const RUTAS = {
    PANEL: 'admin',
    USUARIOS: 'usuarios',
    GRUPOS: 'grupos',
    ETAPAS: 'etapas',
    PERFILES: 'perfiles',
    SECTORES_COMERCIALES: 'sectores-comerciales',
    EVENTOS: 'eventos'
} as const

export default RUTAS
